// 经络辨证模块
// - sys_company_id==84 且非 flow_step==19：把倾向体质的经络数据合并到 tizhi_jingluo
// - flow_step==19 时不显示经络数据
// 依赖：tizhi_jingluo / tizhi_jingluo_qingxiang / tizhi_content 已在 pipeline.parseBase 完成 JSON.parse

export default function transform(data) {
    if (!data) return;

    const isFlowStep19 = Number(data.flow_step) === 19;
    const tizhi_content = data.tizhi_content;

    if (
        !isFlowStep19
        && data.sys_company_id == 84
        && tizhi_content
        && Array.isArray(tizhi_content.physique_qingxiang)
        && tizhi_content.physique_qingxiang.length > 0
        && data.tizhi_jingluo
        && data.tizhi_jingluo_qingxiang
        && JSON.stringify(data.tizhi_jingluo_qingxiang) !== '{}'
    ) {
        const physique_qingxiang = tizhi_content.physique_qingxiang;
        for (let i = 0, n = physique_qingxiang.length; i < n; i++) {
            const pq = physique_qingxiang[i];
            data.tizhi_jingluo[`${pq}`] = data.tizhi_jingluo_qingxiang[`${pq}`];
        }
    }

    if (isFlowStep19) {
        data.tizhi_jingluo = '';
    }
}
